import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateIntegrationTypeForm from "@/components/CreateIntegrationTypeForm";

export const Route = createFileRoute("/dashboard/integration-types/new")({
  component: CreateIntegrationTypePage,
});

function CreateIntegrationTypePage() {
  return (
    <EntityFormPage
      title="Create Integration Type"
      description="Add a new type of integration to the catalog."
      backHref="/dashboard/integration-types"
    >
      <CreateIntegrationTypeForm />
    </EntityFormPage>
  );
}
